import React, { Component } from "react";
import PropTypes from "prop-types";
import Disclosure from "./Disclosure";

// TODO:
// . Admin / Super Admin users
// * the option to esign is not present for admin submitted users

class Disclosures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allValid: false,
    };
  }

  static creditAuthText = `I understand and agree that by continuing I am providing written instructions to LendingClub to obtain credit reports about me 
    from one or more consumer reporting agencies to (1) check if I prequalify for financing and (2) verify my identity and the information in my application.  
    I understand that LendingClub may share information from my credit report with (1) its subsidiaries and (2) its partner banks, NBT Bank, N.A. and Comenity 
    Capital Bank.`;

  static pilotCreditAuthText =
    "By checking this box, you acknowledge that you have received, read, and agree to all of the terms of the ";

  static disclosures = {
    esign: {
      isRequired: true,
      elems: [
        {
          text: "By checking this box, you acknowledge that you have received, read, and agree to all of the terms of the ",
        },
        {
          type: "a",
          href: "https://www.lendingclub.com/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FSharedElectronicConsent",
          text: "E-Sign Consent",
          name: "etd",
          target: "_blank",
        },
        { text: "." },
      ],
    },
    creditauth: {
      isRequired: true,
      elems: [
        { text: Disclosures.pilotCreditAuthText },
        {
          type: "a",
          href: "https://www.lendingclub.com/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FApplicationTermsOfUse",
          text: "Application Terms and Conditions",
          target: "_blank",
        },
        { text: "." },
      ],
    },
    privpolicy: {
      isRequired: true,
      elems: [
        {
          text: "By checking this box, you acknowledge that you have received, read, and agree to all of the terms of the ",
        },
        {
          type: "a",
          text: "Credit Profile Authorization",
          href: "https://www.lendingclub.com/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FPersonalCreditProfileAuth",
          name: "creditAuth",
          target: "_blank",
        },
        { text: ", and " },
        {
          type: "a",
          target: "_blank",
          text: "LendingClub Privacy Policy",
          href: "https://www.lendingclub.com/legal/privacy-policy",
        },
        { text: "." },
      ],
    },
  };

  static defaultProps = {
    secName: "sectionDisclosures",
    secTitle: "Application Disclosures",
    sectionStatus: "",
    disclosures: {
      esign: {
        isRequired: false,
        elems: [
          { text: "I consent to the " },
          {
            type: "a",
            href: "/patientsolutions/app/legal/electronic-signature-consent",
            text: "Electronic Transactions & Disclosures",
            name: "etd",
            target: "_blank",
          },
        ],
      },
      creditauth: {
        isRequired: true,
        elems: [{ text: Disclosures.creditAuthText }],
      },
      privpolicy: {
        isRequired: true,
        elems: [
          { text: "By continuing, you agree to the " },
          {
            type: "a",
            href: "/patientsolutions/app/legal/terms-and-conditions",
            text: "Terms & Conditions",
            name: "tc",
            target: "_blank",
          },
          { text: ", " },
          {
            type: "a",
            target: "_blank",
            text: "LendingClub Privacy Policy",
            href: "https://www.lendingclub.com/legal/privacy-policy",
          },
          { text: ", and " },
          {
            type: "a",
            target: "_blank",
            text: "NBT Bank Privacy Policy",
            href: "https://www.nbtbank.com/~/media/Files/PDFs/NBTPrivacyNotice.pdf",
          },
          { text: "." },
        ],
      },
    },
  };

  handleEventCallback = (ev, data) => {
    const { name } = ev.target,
      { onSectionCallback, secName, sectionMetadata } = this.props;

    sectionMetadata.fields[name].value = data.value;
    sectionMetadata.fields[name].status = data.status;
    sectionMetadata.fields[name].isValid = data.isValid;

    if (onSectionCallback && typeof onSectionCallback === "function") {
      onSectionCallback(secName, name, sectionMetadata.fields[name]);
    }
  };

  render() {
    const { secTitle, sectionMetadata } = this.props,
      disclKeys = ["esign", "creditauth", "privpolicy"];
    const disclosures = Disclosures.disclosures;
    return (
      <fieldset className="pf-registration section-4 application-disclosures">
        <legend className="show-for-sr">{secTitle}</legend>
        {disclKeys.map((key) => {
          const data = disclosures[key].elems;
          const isRequired = disclosures[key].isRequired;
          return (
            <Disclosure
              key={key}
              disclosureType={key}
              onEventCallback={this.handleEventCallback}
              content={data}
              isRequired={isRequired}
              fieldMetadata={sectionMetadata.fields[key]}
            />
          );
        })}
      </fieldset>
    );
  }
}

Disclosures.propTypes = {
  userType: PropTypes.string,
  secTitle: PropTypes.string.isRequired,
  disclosures: PropTypes.object.isRequired,
  clientInfo: PropTypes.object.isRequired,
  sectionMetadata: PropTypes.object.isRequired,
  onSectionCallback: PropTypes.func.isRequired,
  sectionStatus: PropTypes.string.isRequired,
  secName: PropTypes.string,
};

export default Disclosures;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');